import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import Breadcrumbs from '../breadcrumbs';
import {Divider} from './components';
import {Wrapper} from 'system/wrapper';
import List from '../list';

import doctor from 'images/general/doctor.svg';
import timetable from 'images/management/timetable.svg';
import hospital from 'images/management/hospital1.svg';
import specialist from 'images/management/doctor1.svg';

class HealthList extends Component {
	render() {
		return (
      <div>
				<Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
        </Breadcrumbs>
				<Wrapper>
					<Grid>
						<h2>Департамент охорони здоров’я</h2>
						<Divider>
							<List>
								<li>
									<Link to="/health-management/direction">
										<div>
											<img src={doctor} alt="Лікарі"/>
										</div>
										<h3>Керівництво</h3>
									</Link>
								</li>
								<li>
									<Link to="/health-management/units">
										<div>
											<img src={hospital} alt="Лікарі"/>
										</div>
										<h3>Підрозділи</h3>
									</Link>
								</li>
								<li>
									<Link to="/health-management/timetable">
										<div>
											<img src={timetable} alt="Лікарі"/>
										</div>
										<h3>Графік прийому</h3>
									</Link>
								</li>
								<li>
									<Link to="/health-management/experts">
										<div>
											<img src={specialist} alt="Лікарі"/>
										</div>
										<h3>Позаштатні фахівці</h3>
									</Link>
								</li>
			        </List>
						</Divider>
					</Grid>
				</Wrapper>
	    </div>
    );
	}
}

export default HealthList;



// WEBPACK FOOTER //
// ./src/system/management/index.js